import { read_quest_provider_counts } from '../../../utils/quest/quest_provider_counts';

/**
 * Checks whether a Brand has a SASS sale or a synchronized Quest identity.
 */
export const read_brand_has_sass_data = (brand = {}) => {
    const tags = Array.isArray(brand?.tags) ? brand.tags : [];
    const questCounts = read_quest_provider_counts(brand);
    const active = questCounts.active;
    const inactive = questCounts.inactive;
    const hasPaidSassTag = tags.some((tag) => {
        const tagKey = `${tag?.key || ''}`.trim().toLowerCase().replace(/[\s-]+/g, '_');
        const tagName = `${tag?.name || ''}`.trim().toLowerCase();

        return tag?.status === true && (tagKey === 'sass_paid' || tagName === 'paid sass');
    });

    return Boolean(
        active
        || inactive
        || brand?.questCounts?.updatedAt
        || brand?.questadBusinessId
        || brand?.questadUserId
        || brand?.questadStatus
        || brand?.questadEnabled === true
        || brand?.activeQuest?.questId
        || `${brand?.paidStatus || ''}`.trim().toLowerCase() === 'paid sass'
        || brand?.actualPaid === true
        || hasPaidSassTag
    );
};

/**
 * Aggregates exact active and inactive Quest totals across every Brand on one Lead.
 */
export const read_prospect_sass_summary = (prospect = {}) => {
    const brands = Array.isArray(prospect?.brands) ? prospect.brands : [];
    const available = brands.some(read_brand_has_sass_data);

    return brands.reduce((summary, brand) => {
        const counts = read_quest_provider_counts(brand);

        return {
            ...summary,
            active: summary.active + counts.active,
            inactive: summary.inactive + counts.inactive,
            byProvider: {
                meta: {
                    active: summary.byProvider.meta.active + counts.byProvider.meta.active,
                    inactive: summary.byProvider.meta.inactive + counts.byProvider.meta.inactive,
                    total: summary.byProvider.meta.total + counts.byProvider.meta.total
                },
                google: {
                    active: summary.byProvider.google.active + counts.byProvider.google.active,
                    inactive: summary.byProvider.google.inactive + counts.byProvider.google.inactive,
                    total: summary.byProvider.google.total + counts.byProvider.google.total
                }
            }
        };
    }, {
        available,
        active: 0,
        inactive: 0,
        byProvider: {
            meta: { active: 0, inactive: 0, total: 0 },
            google: { active: 0, inactive: 0, total: 0 }
        }
    });
};

/**
 * Converts the canonical registration state into the requested table label.
 */
export const read_registered_status = (prospect = {}) => {
    return `${prospect?.registrationStatus || ''}`.trim().toLowerCase() === 'registered';
};
